import {HELP_TOPICS} from './catalog'

/** James's pipeline supplies both fictional assets, named by the stable catalogue ID. */
export function helpVideoPaths(id:string){
  if(!HELP_TOPICS.some(topic=>topic.id===id))throw new RangeError('Unknown help topic')
  return {video:`/help/videos/${id}.mp4`,captions:`/help/videos/${id}.vtt`,poster:`/help/videos/${id}.poster.png`}
}

/** Poster is optional: absence must not disable a valid captioned recording. */
export async function helpPosterAvailable(id:string,signal:AbortSignal,fetcher:typeof fetch=fetch):Promise<boolean>{
  if(signal.aborted)return false
  try{
    const response=await fetcher(helpVideoPaths(id).poster,{method:'HEAD',credentials:'omit',cache:'no-store',redirect:'error',signal})
    return !signal.aborted&&response.ok&&!response.redirected&&response.headers.get('content-type')?.split(';')[0].trim().toLowerCase()==='image/png'&&response.headers.get('content-length')!=='0'
  }catch{return false}
}

/** Check only an opened guide. SPA fallback HTML must never become a broken play button. */
export async function helpVideoAvailable(id:string,signal:AbortSignal,fetcher:typeof fetch=fetch):Promise<boolean>{
  if(signal.aborted)return false
  const paths=helpVideoPaths(id)
  try{
    const responses=await Promise.all([paths.video,paths.captions].map(path=>fetcher(path,{
      method:'HEAD',credentials:'omit',cache:'no-store',redirect:'error',signal,
    })))
    return !signal.aborted&&responses.every((response,index)=>response.ok&&!response.redirected&&
      response.headers.get('content-type')?.split(';')[0].trim().toLowerCase()===(index===0?'video/mp4':'text/vtt')&&
      response.headers.get('content-length')!=='0')
  }catch{return false}
}
